import { PAGES_TYPES } from 'constants/pagesTypes';
import { CAREER_LINKS, CULTURAL_CODE_URL } from 'constants/api';

import { TRAINEE_TG_LINK, TRAINEE_VK_LINK } from 'constants/global';

import CulturalCode from 'assets/icons/cultural_code.png';
import FlameCurved from 'assets/icons/flame-curved.svg';
import CloudUpload from 'assets/icons/cloud-upload.svg';
import Specialists from 'assets/icons/specialists.svg';
import Internship from 'assets/icons/internship.svg';
import plusPerson from 'assets/icons/plusPerson.svg';
import Measuring from 'assets/icons/Measuring.svg';
import Suitcase from 'assets/icons/suitcase.svg';
import HelpDesk from 'assets/icons/helpDesk.svg';
import Company from 'assets/icons/Company.svg';
import Barcode from 'assets/icons/barcode.svg';
import Support from 'assets/icons/support.svg';
import HandUp from 'assets/icons/handUp.svg';
import Secure from 'assets/icons/secure.svg';
import Course from 'assets/icons/course.svg';
import Rocket from 'assets/icons/rocket.svg';
import Signal from 'assets/icons/signal.svg';
import OneC from 'assets/icons/oneC.svg';
import Tool from 'assets/icons/tool.svg';
import Mic from 'assets/icons/mic.svg';
import telegram_logo_black from 'assets/icons/telegram_logo_black.svg';
import vkLogo from 'assets/icons/vk.svg';

const TITLES = {
  domainExpertise: 'Отраслевая экспертиза',
  media: 'ASTON медиа',
  services: 'Сервисы',
  projects: 'Проекты',
  career: 'Карьера',
  aboutUs: 'О нас',
};

export const navButtonsData = [
  {
    text: TITLES.domainExpertise,
    menuData: {
      title: TITLES.domainExpertise,
      text: 'Направления разработки, в которых у нашей команды — обширный опыт, глубокие знания и большое количество успешных решений',
      // btnText: 'Обсудить проект',
      cardsData: [
        {
          src: Secure,
          title: 'Финансовые технологии',
          text: 'Реализуем проекты для лидеров отрасли',
          link: `/${PAGES_TYPES.industries}/${PAGES_TYPES.finTech}`,
        },
        {
          src: Barcode,
          title: 'Розничная торговля',
          text: 'Работаем с топами розничного рынка',
          link: `/${PAGES_TYPES.industries}/${PAGES_TYPES.retail}`,
        },
        {
          src: FlameCurved,
          title: 'Нефтегаз',
          text: 'Разрабатываем продукты для ключевых игроков',
          link: `/${PAGES_TYPES.industries}/${PAGES_TYPES.oilAndGas}`,
          gridColumn: { tablet: 'span 3', mg: 'unset' },
        },
        {
          src: Signal,
          title: 'Телекоммуникации',
          text: 'Повышаем качество операторских услуг',
          link: `/${PAGES_TYPES.industries}/${PAGES_TYPES.telecom}`,
          gridColumn: { tablet: 'span 3', mg: 'unset' },
        },
      ],
    },
  },
  {
    text: TITLES.services,
    menuData: {
      title: TITLES.services,
      text: 'Создаём цифровые решения, которые помогают решать рутинные и глобальные задачи бизнеса',
      // btnText: 'Обсудить задачу.',
      cardsData: [
        {
          src: Measuring,
          title: 'Проектная разработка',
          text: 'Поиск идеально подходящей команды',
          link: `/${PAGES_TYPES.services}/${PAGES_TYPES.mds}`,
          gridColumn: { tablet: 'span 2', mg: 'unset' },
        },
        {
          src: plusPerson,
          title: 'Расширение команды',
          text: 'Оперативное подключение опытных экспертов',
          link: `/${PAGES_TYPES.services}/${PAGES_TYPES.bodyShop}`,
          gridColumn: { tablet: 'span 2', mg: 'unset' },
        },
        {
          src: Specialists,
          title: 'Выделенная команда',
          text: 'Быстрое погружение в специфику проекта',
          link: `/${PAGES_TYPES.services}/${PAGES_TYPES.dedicatedTeam}`,
        },
        {
          src: HandUp,
          title: 'Консультирование',
          text: 'Глубокий анализ бизнеса и рынка',
          link: `/${PAGES_TYPES.services}/${PAGES_TYPES.consulting}`,
        },
        {
          src: OneC,
          title: '1С-разработка',
          text: 'Создаём решения для автоматизации бизнеса',
          link: `/${PAGES_TYPES.oneC}`,
        },
        {
          src: Support,
          title: 'Поддержка',
          text: 'Обслуживание и поддержка клиентов, инфраструктур и приложений',
          link: `/${PAGES_TYPES.services}/${PAGES_TYPES.maintenanceSupport}`,
        },
        {
          src: Tool,
          title: 'Служба ИТ-помощи',
          text: 'Первая, вторая и третья линии поддержки, взаимодействие',
          link: `/${PAGES_TYPES.services}/${PAGES_TYPES.itSupport}`,
        },
        {
          src: HelpDesk,
          title: 'Веб-разработка',
          text: 'Комплексные услуги по веб-разработке',
          link: `/${PAGES_TYPES.services}/${PAGES_TYPES.webDev}`,
        },
        {
          src: CloudUpload,
          title: 'Миграция в облако',
          text: 'Переводим ИТ‑системы в облако',
          link: `/${PAGES_TYPES.services}/${PAGES_TYPES.cloudMigration}`,
        },
      ],
    },
  },
  { text: TITLES.projects, link: `/${PAGES_TYPES.projects}` },
  {
    text: TITLES.career,
    menuData: {
      title: TITLES.career,
      text: 'Развиваем сообщество ИТ\u2011специалистов и помогаем им достигать новых высот',
      tabButtonsListData: [
        { text: 'Телеграм', link: TRAINEE_TG_LINK, icon: telegram_logo_black },
        { text: 'ВКонтакте', link: TRAINEE_VK_LINK, icon: vkLogo },
      ],
      cardsData: [
        {
          src: Company,
          title: 'Работа в ASTON',
          text: 'Предложения от ведущих компаний',
          link: CAREER_LINKS.mainPage,
        },
        {
          src: Suitcase,
          title: 'Вакансии',
          text: 'Для всех уровней',
          link: CAREER_LINKS.vacancyPage,
          tag: '44 вакансии',
        },
        {
          src: Internship,
          title: 'Стажировка',
          text: 'Актуальные знания от экспертов-практиков',
          link: CAREER_LINKS.traineePage,
          tag: '10 направлений',
        },
        {
          src: Course,
          title: 'Курсы',
          text: 'Только востребованные ИТ\u2011профессии',
          link: CAREER_LINKS.coursesPage,
          tag: '6 направлений',
        },
        {
          src: Rocket,
          title: 'Обучение в ASTON',
          text: 'Всё для карьеры в ИТ с нуля',
          link: CAREER_LINKS.laboratoryPage,
          tag: '16 направлений',
        },
      ],
    },
  },
  {
    text: TITLES.media,
    menuData: {
      title: TITLES.media,
      text: 'Увлекательные проекты самой оптимистичной ИТ\u2011компании',
      cardsData: [
        {
          src: CulturalCode,
          title: 'Культурный код',
          text: 'Лекции от признанных учёных России',
          link: CULTURAL_CODE_URL,
        },
        {
          src: Mic,
          title: 'Цифровые горизонты',
          text: 'Тренды и вызовы ИТ-рынка в подкастах с экспертами',
          link: 'https://vkvideo.ru/playlist/-211822073_5',
        },
      ],
    },
  },
  { text: TITLES.aboutUs, link: '/about-us' },
];
